/* istanbul ignore next */
const ACTIONS = {
    SET_CARD_DETAILS: 'SET_CARD_DETAILS',
    SET_ACCOUNT_STATUS: 'SET_ACCOUNT_STATUS',
    GET_LEADS_FORM_SITE: 'GET_LEADS_FORM_SITE',
    SET_LANGUAGE: 'SET_LANGUAGE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    setCardDetails(cardQuestionId) {
        return {
            type: ACTIONS.SET_CARD_DETAILS,
            payload: {
                cardQuestionId
            }
        };
    },

    setAccountStatus(status) {
        return {
            type: ACTIONS.SET_ACCOUNT_STATUS,
            payload: {
                status
            }
        };
    },

    setLanguage(language) {
        return {
            type: ACTIONS.SET_LANGUAGE,
            payload: {
                language
            }
        };
    },

    getLeadsFormSite(siteName) {
        return {
            type: ACTIONS.GET_LEADS_FORM_SITE,
            payload: {
                siteName
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
